import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router';
import withAutocomplete from '../../hoc/withAutocomplete';
import Autocompleter from '../autocompleter';
import './searchbar.scss';

const SearchBar = (props) => {

    const { suggestions } = props;


    if (props.roles.menuItems.indexOf('Delfiregister') === -1) {
        return null;
    } 

    return (
        <form method="get" action="/search" className={classNames({
            'search-bar__inner': true
        })}>
            <div className="search-bar__q-container">
                <input  
                type="search" 
                name="searchText"
                className={classNames({
                        'search-bar__q': true,
                        'search-bar__q--is-open': suggestions.isVisible,
                })}                   
                autoComplete="off" 
                onKeyDown={(e) => props.handleKeyDown(e)}
                onChange={(e) => props.handleChange(e)} 
                onFocus={(e) => props.handleFocus(e)}
                value={suggestions.value}
                placeholder={suggestions.isVisible ? 'Sök enhet, kedja, adress osv' : 'Vad letar du efter?'} />
                <Autocompleter {...props} />
            </div>
            <button type="submit" className="search-bar__button">Sök</button>
    </form>
    );
};

export default withRouter(withAutocomplete(SearchBar));